// extracted by mini-css-extract-plugin
export default {"galleryItem":"c-p_eX","galleryItem_borderTopRadius":"c-p_eY","galleryItem__image":"c-p_eZ"};